/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Typography from "@mui/material/Typography";
import { Button, Stack } from "@mui/material";
import { Link } from "react-router";

const QuestionsContactSection = () => {
  return (
    <Stack
      direction={"column"}
      sx={{
        alignItems: "center",
        marginTop: "20px"
      }}>
      <Typography variant={"h4"}>Sie haben noch Fragen?</Typography>
      <Typography>Wir helfen Ihnen gerne. Schicken Sie uns jederzeit eine Nachricht in Ihrer Servicewelt.</Typography>
      <Button component={Link} to={"/servicewelt/nachrichten"} variant={"contained"} sx={{ marginTop: 2 }}>
        Zu meinen Nachrichten
      </Button>
    </Stack>
  );
};

export default QuestionsContactSection;
